/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/28
 */
import React from 'react';
import classNames from 'classname';
import {connect} from 'react-redux';
import {updateExpressType} from '../../../actions/step';

const Item = ({ title, tips, value, pickupType, updateExpressType }) => {
  const className = classNames('mcycle-express-checkbox', {
    'checked': pickupType === value
  });
  return <div className={className}>
    <div className="mcycle-checkbox-content" onClick={() => updateExpressType(value)}>
      <p className="mcycle-checkbox-title">{title}</p>
    </div>
    <div className="mcycle-checkbox-tips">{tips}</div>
  </div>
};

export default connect(
  state => ({
    pickupType: state.step.expressInfo.pickupType
  }),
  {updateExpressType}
)(Item);



// WEBPACK FOOTER //
// ./src/components/step2/selectType/item.js